<template>
  <sui-card class="state-card">
    <sui-card-content class="compact">
      <b>Image</b>
    </sui-card-content>
    <a class="content link" :href="link" target="_blank" title="Open image webpage" data-goal="SERVICE_PAGE_IMAGE_OPEN">
      <Logo :entity="service" />
      <b>{{title}}</b>
      <div class="aside">
        <sui-button attached="left" size="mini" color="green" v-if="type === 'official'">Official</sui-button>
        <sui-button attached="left" size="mini" color="blue" v-if="type === 'team'">{{this.link.split('/')[4]}}</sui-button>
        <sui-button attached="left" size="mini" color="grey" v-if="type === 'custom'">Custom</sui-button>
      </div>
    </a>
    <sui-dimmer :active="hasError" @click="error = null">
      <p><b>Error!</b></p>
      <p><small>{{error}}</small></p>
    </sui-dimmer>
    <sui-button-group class="fluid" size="mini" attached="bottom">
      <sui-button :disabled="isUpdateDisabled" @click="updateService()" data-goal="SERVICE_PAGE_IMAGE_UPDATE">Update version</sui-button>
    </sui-button-group>
  </sui-card>
</template>

<script>
  import {mapGetters} from 'vuex'
  import objects from '@/objects'

  export default {
    name: 'ServiceImageCard',
    props: {
      service: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        error: null,
      }
    },
    computed: {
      ...mapGetters(['actionsById']),
      actions() {
        return this.actionsById[this.service.id]
      },
      hasError() {
        return Boolean(this.error)
      },
      title() {
        return `${this.service._typeTitle} ${this.service.version}`
      },
      link() {
        return this.service._dockerLink
      },
      isUpdateDisabled() {
        return this.service._inProgress || !this.service._isDeployed || !this.actions.serviceUpdate
      },
      type() {
        if (objects.ServiceDocker.fields.image.official.includes(this.service.image)) {
          return 'official'
        }
        if (this.service.image.includes('/')) {
          return 'team'
        }
        return 'custom'
      },
    },
    methods: {
      updateService() {
        return this.$modals.confirm.open({
          text: 'You are going to update version of service image.',
          callback: () => {
            this.service.applyActions(['DOCKER_FORCE_REBUILD', 'REBUILD']).catch(error => {
              this.error = error.message
            })
          },
        })
      },
    },
  }
</script>

<style scoped>
  .logo { height: 3.6rem; }
  .aside { position: absolute; right: 0; top: 5%; max-height: 90%; display: flex; flex-direction: column; align-items: flex-start; }
  .aside .button { padding: .3em!important; font-size: .8em!important; white-space: nowrap; }
</style>
